import {
  AppMainContainer,
  AppPagination,
  AppSubContainer,
} from "../../../Libraries";
import { LanguageContext } from "../../../context/LanguageContext";
import { GET_SELLER_LEDGER } from "../../../apis/configuration";
import { useContext, useEffect, useState } from "react";
import fourOFour from "../../../assets/images/404.webp";
import {
  AppNonIdeal,
  FilterNonIdeal,
  InnerWrapper,
  MainContainer,
  TitleAndActionBox,
} from "../../common";
import { handleApi } from "../../../apis";
import { Grid, CircularProgress, Box } from "@mui/material";
import HeaderItem from "./HeaderItem";
import Listitem from "./Listitem";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { TABLE_FILTERS_LEDGER } from "../../../constants";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";
import { buildFiltersConfig, dateFormatInNumberWithSpace } from "../../../utils";
import AppTableFilters from "../../common/AppTableFilters";
import NonIdealNew from "../../common/NonIdealNew";

const ViewLedger = () => {

  const [I18n] = useContext(LanguageContext);

  const {
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
  } = useFiltersHandler(undefined, I18n);


  const [loader, setLoader] = useState({
    searchLoad: false,
    pageLoad: false,
    loading: true,
  });
  const [ledgerObj, setLedgerObj] = useState({
    isList: false,
    list: [],
    count: 0,
  });

  const navigate = useNavigate();
  let isFilterApplied = Boolean(filters.keywords || (filters.date?.startDate && filters.date?.endDate));

  const handleLoader = (offset, filters, isLoad = false) => {
    if (offset > 0) setLoader({ ...loader, pageLoad: isLoad });
    else if (filters) setLoader({ ...loader, searchLoad: isLoad });
    else setLoader({ ...loader, loading: isLoad });
  };

  const getLedger = async (
    allFilters = undefined,
    offset = 0,
  ) => {
    try {
      handleLoader(offset, allFilters, true);

      let params = { offset, limit: 20 };

      if (allFilters) params = { ...params, ...allFilters };

      let { data } = await handleApi(GET_SELLER_LEDGER, params, null, navigate);
      const { results, count } = data || {};

      let obj = { ...ledgerObj };

      obj = {
        ...obj,
        list: offset > 0 ? [...ledgerObj.list, ...results] : results,
        count,
      };
      obj = { ...obj, isList: Boolean(count) };

      setLedgerObj(obj);
    } catch (err) {
    } finally {
      handleLoader(offset, allFilters, false);
    }
  };


  useEffect(() => {
    onApply(0, filters);
  }, [filters]);


  const onApply = (offset = 0, filters) => {
    const { startDate, endDate } = filters?.date || {};
    const keyword = filters?.keywords
    if (keyword)
      triggerLogEvent(analytics, "sc_ledger_search", { keyword });
    if (startDate && endDate) {
      let start_date = dateFormatInNumberWithSpace(startDate);
      let end_date = dateFormatInNumberWithSpace(endDate);

      let params = { start_date, end_date };

      if (keyword) params = { ...params, keyword };

      triggerLogEvent(analytics, "sc_ledger_date_filter", { start_date, end_date });

      getLedger(params, offset);
    } else getLedger(keyword ? { keyword } : undefined, offset);
  };


  return true ? (
    <MainContainer fluid className={"quickSalePage"}>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: "ledger_entries",
              isBack: true,
            }}
          />
          <InnerWrapper className="innerWrapper newInnerWrapper">
            {loader.loading ? (
              <div className="orderLoaderMain">
                <CircularProgress size={24} className="loaderCircle" />
              </div>
            ) : !ledgerObj.isList && !isFilterApplied ?
              <NonIdealNew
                subtitle={I18n.ledger_non_ideal_desc}
                title={I18n.ledger_management}
                loading={false}
              /> :
              <Box className={"AccountWrapper"}>
                <AppTableFilters
                  filters={TABLE_FILTERS_LEDGER}
                  onFilterChange={handleFilterChange}
                  appliedChips={appliedChips}
                  filterState={filters}
                  onRemoveChip={(chip) => handleRemoveChip(chip)}
                  filtersConfig={buildFiltersConfig(TABLE_FILTERS_LEDGER, null, null, null, null, null, null, null, null, I18n)}
                  isResetFilter={isResetFilter}
                  setIsResetFilter={setIsResetFilter}

                />
                <HeaderItem />
                {
                  loader.searchLoad ? (
                    <div className="orderLoaderMain">
                      <CircularProgress size={24} className="loaderCircle" />
                    </div>
                  ) :

                    <Box
                      className={`${"accountListBodyWarpper"} generic-scrollbar`}
                      id="scrollableDiv"
                    >
                      {ledgerObj.list.length > 0 ? (
                        <AppPagination
                          data={{
                            handleNext: (page) => onApply(page, filters),
                            pageLoad: loader.pageLoad,
                            count: ledgerObj.count,
                            list: ledgerObj.list,
                            scrollableTarget: "scrollableDiv",
                          }}
                        >
                          {ledgerObj.list.map((item, index) => (
                            <Listitem
                              index={index}
                              key={index}
                              item={item}
                              I18n={I18n}
                            />
                          ))}
                        </AppPagination>
                      ) : <Box className="h-100">
                        <FilterNonIdeal
                          title={I18n.no_ledger_matching_those_filters}
                          subTitle={I18n.try_adjusting_filters}
                          subTitleTextOnClick={() => resetFilters()}
                          subTitleText={I18n.reset_small}
                        />
                      </Box>}
                    </Box>
                }
              </Box>
            }
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  ) : (
    <AppMainContainer>
      <AppSubContainer>
        <AppNonIdeal
          data={{
            title: I18n.page_not_found,
            subtitle: I18n.we_re_sorry_the_page_you_requested,
            image: fourOFour,
            I18n,
          }}
          MainContainer
        />
      </AppSubContainer>
    </AppMainContainer>
  );
};

export default ViewLedger;
